module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isGuest) ? _c('div', {
    staticClass: "sign-in"
  }, [_c('sk-panel', [_c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('h3', {
    staticClass: "sign-in__heading"
  }, [_vm._v("Sign in for a personalised experience")]), _vm._v(" "), _c('sk-input', {
    attrs: {
      "light": "",
      "placeholder": "Email",
      "name": "email",
      "type": "email",
      "error-message": {
        valueMissing: 'Please enter your email address'
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "light": "",
      "type": "password",
      "placeholder": "Password",
      "error-message": {
        valueMissing: 'Please enter your password.'
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.login()
      }
    }
  }, [_vm._v("Sign in")])], 1), _vm._v(" "), _c('p', [_vm._v("Haven't created an SK profile yet? Create one now to customise your movie preferences and enjoy quick bookings. "), _c('sk-button', {
    attrs: {
      "small": "",
      "link": "",
      "router": "",
      "to": {
        path: '/user/signup'
      }
    }
  }, [_vm._v("Create a profile")])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "no-gutter": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs10": "",
      "lg7": ""
    }
  }), _vm._v(" "), _c('sk-spacer')], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0170d896","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/signin/signin.vue
// module id = 884
// module chunks = 0